import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_mst_attribute_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.TextDatatypeInterface;
  type: fromDatatype.VarcharDatatypeInterface;
  required: boolean;
  attribute_code: fromDatatype.TextDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  attribute_name: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_mst_attribute_hdr_RowClass
  implements bl_fi_mst_attribute_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.TextDatatypeInterface;
  type: fromDatatype.VarcharDatatypeInterface;
  required: boolean;
  attribute_code: fromDatatype.TextDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  attribute_name: fromDatatype.VarcharDatatypeInterface;
}
